import { API } from '@Providers';

// TODO - AF-545 Missing interface
export default async function (payload: any) {
  const endpoint = '/api/shelter/cart/add-additional-rto-cost/';

  return API({ endpoint, method: 'post', payload });
}
